import FieldPopover from "../../../fields3/generic/popover/popover"

import FieldStoryPoints_Popover from "./components/popover/popover"
import FieldStoryPoints_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldStoryPoints_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldStoryPoints_View from "./render/view"
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import FieldConfig from "../../proto/field-config"
import FieldStoryPoint_QuickFilterView from "./render/quick-filter-view"
import FieldTaskStoryPoints_ConditionForm from "./render/condition"
import {FieldFilterType, FieldGroupAllPossibleValues_Params} from "../../proto/types"
import {
    FIELD_CONDITIONS_DROPDOWN, FieldConditionsDropdown_NotSetOption,
    FieldDropdown_filterFunc,
} from "../../conditions/dropdown"
import FieldStoryPoints_TableCellCalculated from "./render/table/calculated/table-cell-calculated"
import {AggregateFunctionType} from "../../../data-structures/aggregators/types"
import FieldNumber_AggregateCell from "../number/render/aggregate/aggregate-cell"
import FieldStoryPoints_ViewGroup from "./render/group/group"
import FieldNumber_BoardAggregate from "../number/render/aggregate/board-aggregate"

// const debug = "FieldStoryPoints"
const debug = false

export default class FieldStoryPoints extends FieldPopover {

    FIELD_DEFAULT_WIDTH = 100;

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel                              = "Story points"
        this.filterType                             = FieldFilterType.DROPDOWN
        this.typeGroup                              = GROUP_MISC
        this.typeDescription                        = "Story points selector"
        this.icon                                   = 'i5-story-points'

        this.isSearchable                           = false
        this.isFilterAvailable                      = true

        this.conditionTypes                         = FIELD_CONDITIONS_DROPDOWN

        this.options                                = _.get(config,'options', gd.company.settings.fields.storyPoints) // [{value, label, color},...]

        this.hasCalculatedValues                    = true
        this.isGroupByAllOptionsAvailable           = true

        this.components.PopoverMenu                 = FieldStoryPoints_Popover
        this.components.FormValueNotEmpty           = FieldStoryPoints_FormValueNotEmpty
        this.components.InlineValueNotEmpty         = FieldStoryPoints_InlineValueNotEmpty

        this.renderComponents.view                  = FieldStoryPoints_View
        this.renderComponents.viewSmall             = FieldStoryPoints_View
        this.renderComponents.quickFilterView       = FieldStoryPoint_QuickFilterView

        this.renderComponents.conditionForm         = FieldTaskStoryPoints_ConditionForm
        this.renderComponents.filterForm            = FieldTaskStoryPoints_ConditionForm

        this.renderComponents.tableCell             = FieldStoryPoints_TableCellCalculated
        this.renderComponents.tableCellCalculated   = FieldStoryPoints_TableCellCalculated
        this.renderComponents.aggregateCell         = FieldNumber_AggregateCell
        this.renderComponents.boardAggregate        = FieldNumber_BoardAggregate
        this.renderComponents.viewGroup             = FieldStoryPoints_ViewGroup

        this.filterFunc                             = FieldDropdown_filterFunc
        // this.filterValuesFiller                 = FieldDropdown_filterValuesFiller
    }

    // /*** AUTOMATION (EXPERIMENTAL) ***/
    // get automation() {
    //
    //     if (!this._automation) {
    //         this._automation = new StoryPointsDropdownAutomation(this)
    //     }
    //
    //     return this._automation
    // }

    /*** DATA FUNCTIONS ***/

    sortValue(value:any, model?:any) {
        return value ? parseInt(value) : 0
    }

    countValue(model: any): number {
        return model[this.fieldId] || 0
    }

    filterGetAllOptions(): Option[] {
        // Ensure all options are included so that any selected options are displayed,
        // even if they are no longer available in the selector popover.
        let allOptions = [FieldConditionsDropdown_NotSetOption]

        const options = this.getOptions()
        if (options) {
            allOptions = allOptions.concat(options)
        }

        return allOptions
    }

    /** AGGREGATE **/
    getAggregateOptions() {return [
        AggregateFunctionType.SUM,
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.SUM
    }

    /** GROUP BY **/
    groupValue(value:any) {
        const groupValue = typeof value === 'string' ? parseInt(value) : value
        debug && console.log(debug, 'groupValue', groupValue, _.isNil(groupValue), typeof groupValue)

        return groupValue
    }

    groupLabel(value:any) {
        const groupValue = this.groupValue(value)
        const groupLabel = _.isNaN(groupValue) ? 'Not set' : groupValue
        debug && console.log(debug, 'groupLabel', value, groupLabel)
        return groupLabel
    }

    getGroupObject(value: any) {
        const storyPoints = gd.company.settings.fields.storyPoints;
        const found = _.find(storyPoints, sp=>sp.value === value);

        return {
            id      : found ? found.value : value,
            value   : found ? found.value : value,
            label   : found ? found.label : value,
            name    : _.get(found, 'label', 'Not selected'),
        }
    }

    groupAllPossibleValues(params: FieldGroupAllPossibleValues_Params): any[] {
        const res: any[] = [
            null, // not selected value
        ]

        _.map(gd.session.companies.get(gd.companyId).settings.fields.storyPoints, sp=>{
            res.push(sp.value)
        })

        return _.orderBy(res,
            [
                // null/undefined values are sorted first/last depending on direction
                (value: any) => {
                    return _.isNil(value) ? 0 : 1
                },
                // actual group value using field sort function
                (value: any) => {
                    return this.groupSortValue(value, params.groupBy)
                },
            ],
            [
                params.groupBy.sortDirection,
                params.groupBy.sortDirection
            ],
        )
    }
}
